"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactCompoundSlider = require("react-compound-slider");

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

var _Slider = _interopRequireDefault(require("./Slider2.Handle"));

var _Slider2 = _interopRequireDefault(require("./Slider2.Track"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Slider2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider2, _React$Component);

  function Slider2() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Slider2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Slider2)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      values: [_this.props.defaultValue],
      update: [_this.props.defaultValue]
    };

    _this.onUpdate = function (update) {
      _this.setState({
        update: update
      });

      _this.props.onUpdate && _this.props.onUpdate(update[0]);
    };

    _this.onChange = function (values) {
      _this.setState({
        values: values
      });

      _this.props.onChange && _this.props.onChange(values[0]);
    };

    _this.onStart = function (values) {
      _this.setState({
        values: values
      });

      _this.props.onSlideStart && _this.props.onSlideStart(values[0]);
    };

    return _this;
  }

  _createClass(Slider2, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var values = this.state.values;

      var _this$props = this.props,
          variant = _this$props.variant,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          onFocus = _this$props.onFocus,
          _onKeyDown = _this$props.onKeyDown,
          onBlur = _this$props.onBlur,
          restProps = _objectWithoutProperties(_this$props, ["variant", "min", "max", "step", "onFocus", "onKeyDown", "onBlur"]);

      return _react["default"].createElement(Container, null, _react["default"].createElement(StyledSlider, _extends({
        mode: 1,
        step: step,
        domain: [min, max],
        onUpdate: this.onUpdate,
        onChange: this.onChange,
        onSlideStart: this.onSlideStart,
        values: values,
        variant: variant
      }, restProps), _react["default"].createElement(_reactCompoundSlider.Rail, null, function (_ref) {
        var getRailProps = _ref.getRailProps;
        return _react["default"].createElement(StyledRail, getRailProps());
      }), _react["default"].createElement(_reactCompoundSlider.Handles, null, function (_ref2) {
        var handles = _ref2.handles,
            getHandleProps = _ref2.getHandleProps;
        return _react["default"].createElement("div", {
          className: "slider-handles"
        }, handles.map(function (handle, index) {
          var _getHandleProps = getHandleProps(handle.id),
              handleKeyDown = _getHandleProps.onKeyDown,
              restHandleProps = _objectWithoutProperties(_getHandleProps, ["onKeyDown"]);

          return _react["default"].createElement(StyledHandle, _extends({
            key: handle.id,
            handle: handle,
            domain: [_this2.props.min, _this2.props.max],
            getHandleProps: getHandleProps,
            variant: variant,
            onFocus: onFocus,
            onBlur: onBlur
          }, restHandleProps, {
            tabIndex: index,
            onKeyDown: function onKeyDown(e) {
              if (_onKeyDown) {
                _onKeyDown(e.keyCode);
              }

              handleKeyDown(e);
            }
          }));
        }));
      }), _react["default"].createElement(_reactCompoundSlider.Tracks, {
        right: false
      }, function (_ref3) {
        var tracks = _ref3.tracks,
            getTrackProps = _ref3.getTrackProps;
        return _react["default"].createElement(StyledTracks, {
          variant: variant
        }, tracks.map(function (_ref4) {
          var id = _ref4.id,
              source = _ref4.source,
              target = _ref4.target;
          return _react["default"].createElement(_Slider2["default"], {
            key: id,
            source: source,
            target: target,
            getTrackProps: getTrackProps,
            variant: variant
          });
        }));
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Need this to dynamically update state from props
      if (props.defaultValue !== state.values[0]) {
        return {
          values: [props.defaultValue]
        };
      } // Return null if the state hasn't changed


      return null;
    }
  }]);

  return Slider2;
}(_react["default"].Component);

Slider2.themeProps = {
  container: {
    name: "SLIDER2_CONTAINER",
    description: "Container style",
    type: _themeContants.themePropTypes.style
  },
  slider: {
    name: "SLIDER2_SLIDER",
    description: "Slider outer style",
    type: _themeContants.themePropTypes.style
  },
  rail: {
    name: "SLIDER2_RAIL",
    description: "Rail style",
    type: _themeContants.themePropTypes.style
  },
  tracks: {
    name: "SLIDER2_TRACKS",
    description: "Tracks style",
    type: _themeContants.themePropTypes.style
  },
  handle: {
    name: "SLIDER2_HANDLE",
    description: "Handle style",
    type: _themeContants.themePropTypes.style
  }
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Slider2__Container",
  componentId: "ob6598-0"
})(["height:", ";padding-top:", ";width:100%;", ";"], _theming.spacing.medium, _theming.spacing.tiny, (0, _theming.applyVariants)(Slider2.themeProps.container));

var StyledSlider = (0, _styledComponents["default"])(_reactCompoundSlider.Slider).withConfig({
  displayName: "Slider2__StyledSlider",
  componentId: "ob6598-1"
})(["position:relative;width:100%;", ";"], (0, _theming.applyVariants)(Slider2.themeProps.slider));

var StyledRail = _styledComponents["default"].div.withConfig({
  displayName: "Slider2__StyledRail",
  componentId: "ob6598-2"
})(["position:absolute;width:100%;height:14px;border-radius:7px;cursor:pointer;background-color:", ";", ";"], _theming.color.gray, (0, _theming.applyVariants)(Slider2.themeProps.rail));

var StyledHandle = (0, _styledComponents["default"])(_Slider["default"]).withConfig({
  displayName: "Slider2__StyledHandle",
  componentId: "ob6598-3"
})(["", ";"], (0, _theming.applyVariants)(Slider2.themeProps.handle));

var StyledTracks = _styledComponents["default"].div.withConfig({
  displayName: "Slider2__StyledTracks",
  componentId: "ob6598-4"
})(["", ";"], (0, _theming.applyVariants)(Slider2.themeProps.tracks));

Slider2.defaultProps = {
  className: "",
  min: 0,
  max: 100,
  step: 10,
  defaultValue: 0
};
Slider2.propTypes = {
  className: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  step: _propTypes["default"].number,
  defaultValue: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func
  /** @component */

};
var _default = Slider2;
exports["default"] = _default;